import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { Permissions } from '../../../common/constants';
import { AuthenticationService } from '../../../service/authentication.service';

@Component({
    selector: 'unavailable-feature-banner',
    template: require('./unavailable-feature-banner.component.html'),
    styles: [`
        .unavailable-feature-container {
            min-width: 250px;
            border-radius: 4px;
            padding: 16px;
            gap: 24px;
            background-color: #F5F5F5;
        }
    `]
})
export class UnavailableFeatureBannerComponent implements OnInit {

    @Input() features: string[];

    canManageSubscription: boolean;

    constructor(@Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService) { }

    ngOnInit(): void {
        this.canManageSubscription = (this.authenticationService.isCustomerUser() || this.authenticationService.isPartnerUser()) && this.authenticationService.hasPermission(Permissions.ACCOUNT_ADMINISTRATOR);
    }
}